import React, { useState, useEffect } from "react";
import { FiDownloadCloud } from "react-icons/fi";
import { BsFileEarmarkExcel } from "react-icons/bs";
import { CiFileOn } from "react-icons/ci";
import { MdOutlineFileOpen } from "react-icons/md";

const FilePreview = ({ HandleClosePreview, openPreview, fileUrl, filename }) => {
    const [fileExtension, setFileExtension] = useState("");

    useEffect(() => {
        if (filename) {
            setFileExtension(filename.split(".").pop().toLowerCase());
        }
    }, [filename]);

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const renderFilePreview = () => {
        if (!filename) return <p>No file selected</p>;

        if (["png", "jpg", "jpeg", "gif"].includes(fileExtension)) {
            return <img src={fileUrl} alt={filename} className="preview_image_file" />;
        }

        if (["csv", "xls", "xlsx"].includes(fileExtension)) {
            return (
                <div className="file_icon_wrapper">
                    <BsFileEarmarkExcel size={100} color="#1D6F42" />
                    <p>{filename}</p>
                </div>
            );
        }

        if (["pdf", "doc", "docx"].includes(fileExtension)) {
            return (
                <div className="file_icon_wrapper">
                    <CiFileOn size={100} color="#555" />
                    <p>{filename}</p>
                </div>
            );
        }

        return (
            <div className="file_icon_wrapper">
                <MdOutlineFileOpen size={100} color="#888" />
                <p>{filename}</p>
            </div>
        );
    };

    return (
        <div className={openPreview ? "file_preview_container" : "file_preview_container_closed"}>
            <div className="open_preview_header">
                <p>{filename || "No file selected"}</p>
                <i onClick={HandleClosePreview} className="fa-solid fa-x"></i>
            </div>
            <div className="file_content">{renderFilePreview()}</div>
            <div className="open_preview_footer">
                <button onClick={handleDownload}>
                    <FiDownloadCloud /> Download
                </button>
            </div>
        </div>
    );
};

export default FilePreview;
